import axios from '@/libs/api.request'
const completionBill = {
    // 保存完工单
    saveCompletionBill: (data) => {
      return axios.put({
          url: '/CompletionBill',
          data:data
      })
    },
    // 获取模板列表
    getCompletionBill: (id) => {
        return axios.get({
            url: '/CompletionBill?Id='+id
        })
    },
    // 查看今日完工单据列表
    getCompletionBillList: () => {
      return axios.get({
          url: '/CompletionBill/list'
      })
  }
}
export default completionBill


// WEBPACK FOOTER //
// ./src/api/api-completionBill.js